import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import store from '../redux/store.js';

export default function useLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const doLogout = () => {
    try {
      console.log('Starting cleanup on logout...');
      
      // Get Matrix client from Redux state before clearing it
      const state = store.getState();
      const matrixClient = state.chatDetails?.matrixClient;
      
      // Stop Matrix client if it exists
      if (matrixClient) {
        console.log('Stopping Matrix client...');
        try {
          // Add guard to prevent multiple stops
          if (!matrixClient._isStopped && matrixClient.stopClient && typeof matrixClient.stopClient === 'function') {
            matrixClient.stopClient();
            matrixClient._isStopped = true; // Mark as stopped
            console.log('Matrix client stopped successfully');
          }
          
          // Remove all event listeners (idempotent)
          if (matrixClient.removeAllListeners && typeof matrixClient.removeAllListeners === 'function') {
            matrixClient.removeAllListeners();
            console.log('Matrix client listeners removed');
          }
        } catch (error) {
          console.warn('Could not stop Matrix client:', error);
        }
      }
      
      // Clear all intervals from localStorage
      const intervalIds = JSON.parse(localStorage.getItem('activeIntervals') || '[]');
      console.log(`Clearing ${intervalIds.length} active intervals:`, intervalIds);
      
      intervalIds.forEach(intervalId => {
        clearInterval(intervalId);
      });
      
      // Clear interval storage
      localStorage.removeItem('activeIntervals');
      
      // Clear all localStorage data on logout
      localStorage.clear();
      console.log('All cleanup completed - localStorage cleared');
      
      dispatch({ type: 'logout' });
      dispatch({ type: 'logoutPractice' });
      dispatch({ type: 'clearMessage' });
      dispatch({ type: 'clearMatrixClient' });
      dispatch({ type: 'clearMatrixServer' });
    } catch (err) {
      console.error('Logout dispatch failed in hook', err);
    }
    navigate('/');
  };

  return doLogout;
}
